import { render } from "./MyData.vue?vue&type=template&id=a5b105f6&scoped=true"
import script from "./MyData.vue?vue&type=script&lang=js"
export * from "./MyData.vue?vue&type=script&lang=js"

import "./MyData.vue?vue&type=style&index=0&id=a5b105f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5b105f6"]])

export default __exports__